import * as React from "react"
import { Link } from "react-router-dom"
import Stack from 'react-bootstrap/Stack';
import {NavigationBar, Layout} from "./layout"
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Typography } from "@mui/material";

const Activities = () => {
  let chanClass=  <Stack direction="horizontal" gap={4}>
  <img src="/chanClass.png" width={420} />
  <div><Typography variant="h3" style={{textAlign: "left"}}><b>星期五</b></Typography><Typography variant="body1">下午5：00-6：00 靜坐<br/>
  下午6：00-7：00 禪修開示<br/></Typography>
  <br/><Typography variant="h3" style={{textAlign: "left"}}><b>星期六</b></Typography><Typography variant="body1">下午9：00-10：00 靜坐<br/>
  下午10：00-11：00 禪修開示<br/>
  中午11：00-12：00 素食午餐<br/>
  歡迎各類冥想練習者來和我們一起打坐<br/><br/>
  新人可以<a href="mailto:info@chanpureland.org">郵件我們</a>獲取更多信息 <br/><br/>
  <b>地址：</b> 溈山寺7732 Emerson pl, Rosemead, CA 91770 (教堂建築) <Link to="/location">and more</Link><br/><br/><a href="https://www.youtube.com/c/MasterYongHua/live"><YouTubeIcon fontSize="large" color="error" />觀看直播</a><br/></Typography></div>
  </Stack>;

let sutraLecture=<Stack direction="horizontal" gap={4}>
<div><Typography variant="body1">永化法師以互動的形式講授佛經。講座是用英語進行的。同時提供中、越、韓文翻譯。​</Typography><br/><br/><Typography variant="h3" style={{textAlign: "left"}}><b>星期五</b></Typography><Typography variant="body1">晚上8：30-10：00  <b>大方廣佛華嚴經疏</b></Typography><br/><Typography variant="h3" style={{textAlign: "left"}}><b>周六</b></Typography><Typography variant="body1">
中午12：30-下午2：00 <b>維摩詰經</b></Typography><br/>
<Typography variant="h3" style={{textAlign: "left"}}><b>周日</b></Typography><Typography variant="body1"> 中午12：30-下午2：00  <b>大方廣佛華嚴經第一品</b><br/>
<br/>
<b>地址：</b> 溈山寺7732 Emerson pl, Rosemead, CA 91770 (教堂建築) <Link to="/location">and more</Link><br/><br/><a href="https://www.youtube.com/c/MasterYongHua/live"><YouTubeIcon fontSize="large" color="error" />觀看直播</a><br/></Typography></div>
<div>
<img src="/sutralecturegraphic.png" width={420} />
<img src="/masterTeacher.jpg" width={420} />
</div>
</Stack>;

let mantraSession=<Stack direction="horizontal" gap={4}>
<img src="/mantralecturegraphic.png" width={420} />
<div><Typography variant="body1">咒語是非常強大的禱詞，帶給我們實際和精神上的保護及益處。​</Typography><br/><br/><Typography variant="h3" style={{textAlign: "left"}}><b>星期六</b></Typography><Typography variant="body1">晚上8：00-8：40：誦咒<br/>
楞嚴咒 (544-554行)&emsp;<a href="/Shrugama_Lines544-554.mp3">mp3</a>&emsp;<a href="/Shurangama_Mantra_544_to_554.pdf">pdf</a><br/>
五大心咒 (104-108行)&emsp;<a href="/Shrugama_Lines104-108.mp3">mp3</a>&emsp;<a href="/Shurangama_Mantra_104_to_108.pdf">pdf</a><br/>
Medicine Master Mantra&emsp;<a href="/Medicine_Master_Mantra.mp3">mp3</a>&emsp;<a href="/medicineMasterMantra.pdf">pdf</a><br/>
<br/>
<b>地址：</b> 溈山寺7732 Emerson pl, Rosemead, CA 91770 (教堂建築) <Link to="/location">and more</Link><br/><br/><a href="https://www.youtube.com/c/MasterYongHua/live"><YouTubeIcon fontSize="large" color="error" />觀看直播</a><br/></Typography></div>
</Stack>;

let dharmaAssembly=<Stack direction="horizontal" gap={4}>
<div><Typography variant="body1">週日舉行淨土法會，誦阿彌陀經請求阿彌陀佛加持。每月的最後一個週日，舉行大悲懺法會，祈求觀世音菩薩幫助祈福消災。​​​</Typography><br/><br/><Typography variant="h3" style={{textAlign: "left"}}><b>星期天</b></Typography><Typography variant="body1">下午8：00-9：35 香讚，阿彌陀經<br/>
下午9：40-10：20 開示<br/>
下午10：20-10：45 午供<br/>
中午11：00-11：50 素食午餐<br/>
<br/>
<b>地址：</b> 溈山寺7732 Emerson pl, Rosemead, CA 91770 (教堂建築) <Link to="/location">and more</Link><br/><br/><a href="/calendar.html">法會日曆</a><br/></Typography></div>
<img src="/dharmaassemblygrahic.png" width={420} />
</Stack>;

if((typeof window !== 'undefined') && window.screen.width< 667) {
  chanClass=  <>
  <img src="/chanClass.png" width={420} />
  <div><Typography variant="h3" style={{textAlign: "left"}}><b>星期五</b></Typography><Typography variant="body1">下午5：00-6：00 靜坐<br/>
  下午6：00-7：00 禪修開示<br/></Typography>
  <br/><Typography variant="h3" style={{textAlign: "left"}}><b>星期六</b></Typography><Typography variant="body1">下午9：00-10：00 靜坐<br/>
  下午10：00-11：00 禪修開示<br/>
  中午11：00-12：00 素食午餐<br/>
  歡迎各類冥想練習者來和我們一起打坐<br/><br/>
  新人可以<a href="mailto:info@chanpureland.org">郵件我們</a>獲取更多信息 <br/><br/>
  <b>地址：</b> 溈山寺7732 Emerson pl, Rosemead, CA 91770 (教堂建築) <Link to="/location">and more</Link><br/><br/><a href="https://www.youtube.com/c/MasterYongHua/live"><YouTubeIcon fontSize="large" color="error" />觀看直播</a><br/></Typography></div>
  </>;

sutraLecture=<>
<img src="/sutralecturegraphic.png" width={420} />
<img src="/masterTeacher.jpg" width={420} />
<div><Typography variant="body1">永化法師以互動的形式講授佛經。講座是用英語進行的。同時提供中、越、韓文翻譯。​</Typography><br/><br/><Typography variant="h3" style={{textAlign: "left"}}><b>星期五</b></Typography><Typography variant="body1">晚上8：30-10：00  <b>大方廣佛華嚴經疏</b></Typography><br/><Typography variant="h3" style={{textAlign: "left"}}><b>周六</b></Typography><Typography variant="body1">
中午12：30-下午2：30 <b>六祖坛经</b></Typography><br/>
<Typography variant="h3" style={{textAlign: "left"}}><b>周日</b></Typography><Typography variant="body1"> 中午12：30-下午2：30  <b>大方廣佛華嚴經第一品</b><br/>
<br/>
<b>地址：</b> 溈山寺7732 Emerson pl, Rosemead, CA 91770 (教堂建築) <Link to="/location">and more</Link><br/><br/><a href="https://www.youtube.com/c/MasterYongHua/live"><YouTubeIcon fontSize="large" color="error" />觀看直播</a><br/></Typography></div>
<div>
</div>
</>;

mantraSession=<>
<img src="/mantralecturegraphic.png" width={420} />
<div><Typography variant="body1">咒語是非常強大的禱詞，帶給我們實際和精神上的保護及益處。​</Typography><br/><br/><Typography variant="h3" style={{textAlign: "left"}}><b>星期六</b></Typography><Typography variant="body1">晚上8：00-8：40：誦咒<br/>
楞嚴咒 (544-554行)&emsp;<a href="/Shrugama_Lines544-554.mp3">mp3</a>&emsp;<a href="/Shurangama_Mantra_544_to_554.pdf">pdf</a><br/>
五大心咒 (104-108行)&emsp;<a href="/Shrugama_Lines104-108.mp3">mp3</a>&emsp;<a href="/Shurangama_Mantra_104_to_108.pdf">pdf</a><br/>
Medicine Master Mantra&emsp;<a href="/Medicine_Master_Mantra.mp3">mp3</a>&emsp;<a href="/medicineMasterMantra.pdf">pdf</a><br/>
<br/>
<b>地址：</b> 溈山寺7732 Emerson pl, Rosemead, CA 91770 (教堂建築) <Link to="/location">and more</Link><br/><br/><a href="https://www.youtube.com/c/MasterYongHua/live"><YouTubeIcon fontSize="large" color="error" />觀看直播</a><br/></Typography></div></>

dharmaAssembly=<><img src="/dharmaassemblygrahic.png" width={420} />
<div><Typography variant="body1">週日舉行淨土法會，誦阿彌陀經請求阿彌陀佛加持。每月的最後一個週日，舉行大悲懺法會，祈求觀世音菩薩幫助祈福消災。​​​</Typography><br/><br/><Typography variant="h3" style={{textAlign: "left"}}><b>星期天</b></Typography><Typography variant="body1">下午8：00-9：35 香讚，阿彌陀經<br/>
下午9：40-10：20 開示<br/>
下午10：20-10：45 午供<br/>
中午11：00-11：50 素食午餐<br/>
<br/>
<b>地址：</b> 溈山寺7732 Emerson pl, Rosemead, CA 91770 (教堂建築) <Link to="/location">and more</Link><br/><br/><a href="/calendar.html">法會日曆</a><br/></Typography></div></>

}
  return (
  <><NavigationBar/>
  {/* Hero Image */}
<div style={{ display: "grid" }}>
  <img
    style={{
      gridArea: "1/1",
      // maxHeight: 600,
    }}
    layout="fullWidth"
    aspectRatio={3 / 1}
    alt=""
    src="/activitiesBanner.jpg"
  quality="40"
    formats={["auto", "webp", "avif"]}/>
  <div
    style={{
      gridArea: "1/1",
      position: "relative",
      placeItems: "center",
      display: "grid",
    }}
  >
  </div>
</div>
{/* Main Content */}
  <Layout>
      <Typography variant="h3">
      <strong>週末活動安排</strong>
      </Typography><br/>
  <img src="/chan-meditation-class.png" />
{chanClass}
<img src="/sutra-lecture.png" />
{sutraLecture}
<img src="/mantra-lecture.png" />
{mantraSession}
<img src="/dharma-assembly.png" />
{dharmaAssembly}
  </Layout>
  </>
)}

export default Activities
